import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SecuritySettingsApiService {

  constructor(private http: HttpClient) {}

  readonly securityConfigurationUrl: string = 'configuration/security';

  public getSecurityConfiguration(): Observable<any> {
    return this.http.get(this.securityConfigurationUrl);
  }

  public updateSecurityConfiguration(securityConfiguration): Observable<any> {
    return this.http.put(this.securityConfigurationUrl, securityConfiguration);
  }
}
